import { render } from "./JobData.vue?vue&type=template&id=05a457e2&scoped=true"
import script from "./JobData.vue?vue&type=script&lang=js"
export * from "./JobData.vue?vue&type=script&lang=js"

import "./JobData.vue?vue&type=style&index=0&id=05a457e2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05a457e2"

export default script